// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uujkmJsjXVRh8RdmZtJc {
  display: flex;
  align-items: center;
  gap: 0;
  margin: 12px 0;
}

.rHnY8yZp5WJNhJyhRDop {
  width: 302px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
}

.DMfkZ_y7CvpghVWfKnvd {
  font-family: var(--font-stack-full-regular);
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 500;
  color: var(--grey-color-90);
}

.EUBmt0vrz7jEfrw82v62 {
  font-family: var(--font-stack-full-heavy);
  line-height: 24px;
  font-size: 1rem;
  font-weight: 800;
  color: var(--grey-color-90);
}

.UYaPMCPQxT_G6eprbSkO {
  width: 100%;
  background-color: var(--grey-color-200);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rCXzoFCxnIcVnvEWpS2H {
  width: 302px;
  align-items: center;
}

.vsdhT9NcqFJvrVOMmpjq {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.oB3J_ywxMglRNilyNLul {
  flex: 1 1 48%;
  margin-right: 32px;
}

.aEQGiYoz1qVUPDaLJx4_ {
  display: flex;
  align-items: center;
  flex: 1 1 48%;
}

.Cvs8iJQsCGPEgU_MVOHp {
  display: flex;
}

._aJW9AqsVn73_j7DNE8B {
  writing-mode: vertical-rl;
  padding: 6px 12px;
  text-align: center;
  margin-right: 16px;
  background-color: var(--grey-color-10);
  border-radius: 12px;
}

.PUzumIeEAuqX9KKqKF1i {
  transform: rotate(180deg);
}

.n2EbeQgopObHCuLYNbs4 {
  width: 100%;
  margin-top: 6px;
}

.JfbMqTwHR_jsgWZVfo_E {
  flex: 1 1 48%;
}

.jzNO8dqCSUnI0O5Sy_DG {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.Cfy4zrIti7BCFyRIh3Mz {
  width: 100%;
  margin: 24px 0 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.VrCJFZX2R937yEBcTjhA {
  width: 302px;
}

.ZvzhCEPnxFOjcVnqU7o0 {
  flex: 1 1 auto;
  display: flex;
}

.IBgGvLOFsls9IDsAnQBo {
  flex: 1 1 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 32px;
}

.Oo4xMt0uLwz0fhVffu59 {
  display: flex;
  gap: 2px;
}

.DTsZKm1U0v__9LvpURpf {
  margin: 24px 0;
}

.FReDJ4PDwyUaLkNb_r4M {
  margin: 12px 0;
}

.HTeTXOeO4t7xmkMew2FA {
  height: 1px;
  margin: 18px 0 24px;
  background-color: var(--grey-color-200);
}`, "",{"version":3,"sources":["webpack://./src/components/FactorChart/FactorChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AACA;EACE,yCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,QAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,uCAAA;AAEF","sourcesContent":[".skillsTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin: 12px 0;\n}\n\n.scoreLabelContainer {\n  width: 302px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  cursor: pointer;\n}\n\n.scoringLabel {\n  font-family: var(--font-stack-full-regular);\n  line-height: 1.5;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--grey-color-90);\n}\n.boxlabelTitle {\n  font-family: var(--font-stack-full-heavy);\n  line-height: 24px;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--grey-color-90);\n}\n\n.factorChartHeaderComponentBox {\n  width: 100%;\n  background-color: var(--grey-color-200);\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.titleAverageDistributionBox {\n  width: 302px;\n  align-items: center;\n}\n\n.averageAndDistributionBox {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.averageScoreBox {\n  flex: 1 1 48%;\n  margin-right: 32px;\n}\n\n.distributionLevelBox {\n  display: flex;\n  align-items: center;\n  flex: 1 1 48%;\n}\n\n.mainTitleContainer {\n  display: flex;\n}\n\n.verticalTitleBox {\n  writing-mode: vertical-rl;\n  padding: 6px 12px;\n  text-align: center;\n  margin-right: 16px;\n  background-color: var(--grey-color-10);\n  border-radius: 12px;\n}\n\n.verticalTitle {\n  transform: rotate(180deg);\n}\n\n.titleAverageDistributionContainer {\n  width: 100%;\n  margin-top: 6px;\n}\n\n.distributionLevelMainBoxesContainer {\n  flex: 1 1 48%;\n}\n\n.boxMainTitle {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.secondTitleMainBox {\n  width: 100%;\n  margin: 24px 0 12px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.emptyFirstBox {\n  width: 302px;\n}\n\n.averageAndDistributionTitleContainer {\n  flex: 1 1 auto;\n  display: flex;\n}\n\n.averageScoreAndTargetContainer {\n  flex: 1 1 48%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.targetLabelAndIcon {\n  display: flex;\n  gap: 2px;\n}\n\n.boxesSpacing {\n  margin: 24px 0;\n}\n\n.spacingForMiddleBoxes {\n  margin: 12px 0;\n}\n\n.dividerLine {\n  height: 1px;\n  margin: 18px 0 24px;\n  background-color: var(--grey-color-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skillsTitleContainer": `uujkmJsjXVRh8RdmZtJc`,
	"scoreLabelContainer": `rHnY8yZp5WJNhJyhRDop`,
	"scoringLabel": `DMfkZ_y7CvpghVWfKnvd`,
	"boxlabelTitle": `EUBmt0vrz7jEfrw82v62`,
	"factorChartHeaderComponentBox": `UYaPMCPQxT_G6eprbSkO`,
	"titleAverageDistributionBox": `rCXzoFCxnIcVnvEWpS2H`,
	"averageAndDistributionBox": `vsdhT9NcqFJvrVOMmpjq`,
	"averageScoreBox": `oB3J_ywxMglRNilyNLul`,
	"distributionLevelBox": `aEQGiYoz1qVUPDaLJx4_`,
	"mainTitleContainer": `Cvs8iJQsCGPEgU_MVOHp`,
	"verticalTitleBox": `_aJW9AqsVn73_j7DNE8B`,
	"verticalTitle": `PUzumIeEAuqX9KKqKF1i`,
	"titleAverageDistributionContainer": `n2EbeQgopObHCuLYNbs4`,
	"distributionLevelMainBoxesContainer": `JfbMqTwHR_jsgWZVfo_E`,
	"boxMainTitle": `jzNO8dqCSUnI0O5Sy_DG`,
	"secondTitleMainBox": `Cfy4zrIti7BCFyRIh3Mz`,
	"emptyFirstBox": `VrCJFZX2R937yEBcTjhA`,
	"averageAndDistributionTitleContainer": `ZvzhCEPnxFOjcVnqU7o0`,
	"averageScoreAndTargetContainer": `IBgGvLOFsls9IDsAnQBo`,
	"targetLabelAndIcon": `Oo4xMt0uLwz0fhVffu59`,
	"boxesSpacing": `DTsZKm1U0v__9LvpURpf`,
	"spacingForMiddleBoxes": `FReDJ4PDwyUaLkNb_r4M`,
	"dividerLine": `HTeTXOeO4t7xmkMew2FA`
};
export default ___CSS_LOADER_EXPORT___;
